export default "__VITE_ASSET__BjnPbqIM__"